import { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import {
  Grid,
  Typography,
  Card,
  Button,
  Tooltip,
  IconButton,
} from '@mui/material';
import '../custom.css';
import TableCompanyAdmin from '../components/CompamyManagement/TableCompanyAdmin';
import CardCompany from '../components/CompamyManagement/CardCompany';
import { useLocation } from 'react-router-dom';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { swalClose, swalErrorBtn, swalLoading, swalSuccessBtn } from '../helpers/swalHelper';
import CompanyListApi from '../service/company.api';
import AdminListApi from '../service/admin.api';
import MerchantDialog from '../components/dialogs/company/MerchantDialog';
import AdminDialog from '../components/dialogs/company/AdminDialog';

function CompanyManagement() {
  const [openDialogMerchant, setOpenDialogMerchant] = useState(false);
  const [openDialogAdmin, setOpenDialogAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [companyData2, setCompanyData2] = useState([]);

  const [taxId, setTaxId] = useState('');
  const [name, setName] = useState('');
  const [companyEmail, setCompanyEmail] = useState('');
  const [addressTh, setAddressTh] = useState('');
  const [keyOps, setKeyOps] = useState('');
  const [telCompany, setTelCompany] = useState('');

  const [merchantData, setMerchantData] = useState({
    tax_id: '',
    name: '',
    name_en: '',
    key_ops: '',
    key_api: '',
    branch_id: '',
    address_th: '',
    address_en: '',
    company_Email: '',
    haveBizId: null,
    status_etax: null,
    ops_type: '',
    new_ops: '',
    have_pdf: null,
    allow_manual_payment: null,
    account_contact: '',
    pdf_template_name: {
      invoice: '',
      receipt: ''
    },
    tel: '',
    fax: '',
    company_code: '',
    have_receipt: null,
    allow_edit: null,
    url_path: '',
    logo: ''
  });

  const location = useLocation();
  const { _id, tax_id, status_etax } = location.state || {};
  const [statusETax, setStatusETax] = useState(status_etax || null);
  const [isLinearLoading, setIsLinearLoading] = useState(false);

  const navigate = useNavigate();
  const handleToCompanyList = () => {
    navigate('/company-list');
  };

  const getMerchantDetail = async () => {
    try {
      const data = await CompanyListApi.getCompanyDetailApi(_id);
      const resp = data.company;
      const updateMerchantData = {
        ...merchantData,
        ...resp
      };

      setTaxId(resp.tax_id || '');
      setName(resp.name || '');
      setCompanyEmail(resp.company_Email || '');
      setKeyOps(resp.key_ops || '');
      setAddressTh(resp.address_th || '');
      setTelCompany(resp.tel || '');

      setMerchantData(updateMerchantData);
      return resp;
    } catch (error) {
      console.log("error fetching company");
    }
  };

  const getAdminList = async (tax_id) => {
    try {
      setIsLinearLoading(true);
      const response = await AdminListApi.getAdminListApi(tax_id)
      if (response.data.code !== 200) {
        throw new Error(response.data.message);
      }
      //  console.log('CompanyData2', response.data.admin);

      setCompanyData2(response.data.admin);
    } catch (error) {
      throw new Error(error.message);
    } finally {
      setIsLinearLoading(false);
    }
  };

  const handleSubmitMerchant = async (data, logoBlob) => {
    try {
      await updateMerchant(_id, data, logoBlob);
      setOpenDialogMerchant(false)
      swalSuccessBtn({title: 'บันทึกรายการเรียบร้อยแล้ว'});
    } catch (error) {
      swalErrorBtn({ title: error.message })
      console.error('Error updating company:', error);
    }
  };

  const updateMerchant = async (_id, data, logoBlob) => {
    try {
      swalLoading({ title: 'กำลังอัพเดทข้อมูล...' })
      const response = await CompanyListApi.updateCompanyApi(_id, data, logoBlob);
      if (response.data.code !== 200) {
        throw new Error(response.data.message);
      }
      await getMerchantDetail();

      return response.data.company;
    } catch (error) {
      console.error('Error updating company:', error);
      throw new Error(
        error.response ? error.response.data.message : error.message,
      );
    } finally {
      swalClose()
    }
  }

  const handleSubmitAdmin = async (data) => {
    try {
      // console.log("handleSubmitAdmin",data )
      await AdminListApi.createAdminApi(data);
      setOpenDialogAdmin(false);
      swalSuccessBtn({ title: `บันทึกข้อมูลเรียบร้อย` });
      await getAdminList(tax_id);
    } catch (error) {
      swalErrorBtn({ title: `เกิดข้อผิดพลาด` });
      console.log(error)
    }
  }

  useEffect(() => {
    getAdminList(tax_id);
    getMerchantDetail();
  }, [ _id, tax_id ]);

  return (
    <div>
      <div>
        <Grid container spacing={1}>
          <Grid
            item
            container
            xs={12}
            sm={8}
            md={12}
            lg={7}
            xl={12}
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item container alignItems="center" xs="auto">
              <Tooltip title="ย้อนกลับ" arrow>
                <IconButton onClick={() => handleToCompanyList()}>
                  <ArrowBackIosNewIcon />
                </IconButton>
              </Tooltip>
              <Typography sx={{ ml: 2 }}>
                <div className="container my-2">
                  <div className="text-lg font-light flex items-center justify-between">
                    <div className="py-6 text-xl">การจัดการร้านค้า</div>
                  </div>
                </div>
              </Typography>
            </Grid>
            <Grid item>
              <Button onClick={() => setOpenDialogMerchant(true)} variant="contained" 
                sx={{
                  justifyContent: 'space-between',
                  background: 'primary',
                  color: 'white',
                  width: 'fit-content',
                }}
              > 
                แก้ไขร้านค้า 
              </Button>
            </Grid>
          </Grid>
          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Card
              sx={{
                minWidth: '97%',
                border: '2px solid #4FA893',
                borderRadius: 3,
              }}
            >
              <CardCompany
                tax_id={taxId}
                name={name}
                company_Email={companyEmail}
                key_ops={keyOps}
                address_th={addressTh}
                tel={telCompany}
              />
            </Card>
          </Grid>
          <Grid
            item
            container
            xs={12}
            sm={8}
            md={12}
            lg={7}
            xl={12}
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography sx={{ mr: 2 }}>
              <div className="container my-2 ml-2">
                <div className="text-lg font-light flex items-center justify-between">
                  <div className="py-6 text-xl">การจัดการแอดมิน</div>
                </div>
              </div>
            </Typography>
            <Button
              variant="contained"
              sx={{
                background: 'primary',
                color: 'white',
                width: 'fit-content',
              }}
              onClick={() => setOpenDialogAdmin(true)}
            >
              เพิ่มแอดมิน
            </Button>
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            <TableCompanyAdmin
              tax_id={tax_id}
              companyData2={companyData2}
              isLinearLoading={isLinearLoading}
            />
          </Grid>
        </Grid>
      </div>

      {/* DialogEditCompany */}
      <MerchantDialog
        open={openDialogMerchant}
        onClose={() => setOpenDialogMerchant(false)}
        mode='edit'
        defaultValues={merchantData}
        onSubmit={handleSubmitMerchant}
      />

      <AdminDialog
        open={openDialogAdmin}
        onClose={() => setOpenDialogAdmin(false)}
        mode='create'
        onSubmit={handleSubmitAdmin}
        taxId={tax_id}
      />
    </div>
  );
}

export default CompanyManagement;
